import React, { useCallback, useContext, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Modal, { xcriticalModalClose } from '@xcritical/modal';
import Form, { FormField, xcriticalFormReset } from '@xcritical/forms';

import { ActionsButtons } from '@crm-framework/actions-buttons';
import { capitalize } from '@crm-framework/utils';
import { InputFormField } from '@crm-framework/form-fields';

import {
  CONTACT_DATA_MODAL,
  CONTACT_DATA_FORM,
  IsHorizontalContext,
} from '../consts';
import { checkRightForEdit, contactDataSelector } from '../selectors';

import { checkEditRight } from './utils';

export const ContactDataModal: React.FC<{
  onSave: () => void;
}> = ({ onSave }) => {
  const dispatch = useDispatch();
  const { isOpen, fieldName, isChanged } = useSelector(contactDataSelector);
  const isHorizontal = useContext(IsHorizontalContext);

  const checkingRights = useSelector(checkRightForEdit);

  const canEdit = useMemo(
    () => checkEditRight(fieldName, checkingRights),
    [fieldName, checkingRights]
  );

  const onCloseModal = useCallback(() => {
    dispatch(xcriticalModalClose(CONTACT_DATA_MODAL));
  }, []);

  const onRevertForm = useCallback(() => {
    dispatch(xcriticalFormReset(CONTACT_DATA_FORM));
  }, []);

  return (
    <Modal
      appearance={isHorizontal ? 'previewHorizontalModal' : 'bigModal'}
      name={CONTACT_DATA_MODAL}
      title={capitalize(fieldName)}
      isOpen={isOpen}
      onModalCancel={onCloseModal}>
      <Form name={CONTACT_DATA_FORM}>
        <FormField
          name={fieldName}
          id={fieldName}
          shouldFitContainer
          placeholder="< Empty >"
          autoComplete="off"
          isClearable
          component={InputFormField}
          disabled={!canEdit}
        />
      </Form>
      <ActionsButtons
        className={`${fieldName}-modal`}
        buttons={[
          {
            title: 'Revert',
            appearance: 'menuSubItem',
            onClick: onRevertForm,
            className: 'revert-button',
          },
          {
            title: 'Save',
            appearance: 'primary',
            isDisabled: !canEdit || !isChanged,
            onClick: onSave,
            className: 'save-button',
          },
        ]}
      />
    </Modal>
  );
};
